/// <reference path="../../../../typings/index.d.ts" />
(function($) {
    //Добавление token ко всем ajax запросам
    $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        }
    });
    $('#registration_form').submit(function(event){
        event.preventDefault();
        $('.er').html('');
        var form_data = $(this).serializeArray();
        if (validation()){
            $.ajax({
                type: 'POST',
                url: 'add/user',
                data: form_data,
                dataType: 'json',
                success: function(data) {
                    if (data.code == 202) {
                        window.location.replace("/login");
                    }
                    else {
                        $.each(data.error, function (key, value) {
                            $('.er_serv').append(value + " ");
                        });
                    }
                }
            });
        }        
    });
    //Валидация на стороне клиента
    function validation() {
        $('.er').html('');
        //события при измении поля с данными для сброса поля с ошибкой
        $('#login_reg').change(function(event){
            sbros(val_login(),'.er1');
        });
        $('#name_reg').change(function(event){
            sbros(val_name(),'.er2');
        });
        $('#email_reg').change(function(event){
            sbros(val_email(),'.er3');
        });
        $('#password_reg').change(function(event){
            sbros(val_password(),'.er4');
        });

        //Проверка логина
        function val_login() {
            var valid_name = false;
            var pattern1 = /^.{3,}$/i;

            if ($('#login_reg').val() != '') {
                if (pattern1.test($('#login_reg').val())) {
                    valid_name = true;
                }
                else {
                    $('.er1').html('Логин должен состоять минимум из 3 символов');
                }
            }
            else {
                $('.er1').html('Введите логин');
            }

            return valid_name;
        }

        //Проверка имени
        function val_name() {
            var valid_name = false;
            var pattern1 = /^[а-яa-zё0-9_-]{3,}$/i;
            var pattern2 = /^.{3,}$/i;

            if ($('#name_reg').val() != '') {
                if (pattern1.test($('#name_reg').val())) {
                    valid_name = true;
                }
                else if(pattern2.test($('#name_reg').val())){
                    $('.er2').html('Имя содержит недопустимые символы');
                }
                else {
                    $('.er2').html('Имя должно состоять минимум из 3 символов');
                }
            }
            else {
                $('.er2').html('Введите имя');
            }

            return valid_name;
        }

        //Проверка email
        function val_email(){
            var pattern2 = /^([A-Za-z0-9_\-\.\/])+@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;

            var valid_email = false;
            if ($('#email_reg').val() != '') {
                if (pattern2.test($('#email_reg').val())) {
                    valid_email = true;
                }
                else {
                    $('.er3').html('Введите корректный email');
                }
            }
            else {
                $('.er3').html('Введите email');
            }

            return valid_email;
        }

        //Проверка пароля
        function val_password(){
            var pattern3 = /^.{4,}$/i;

            var valid_password = false;
            if ($('#password_reg').val() != '') {
                if (pattern3.test($('#password_reg').val())) {
                    valid_password = true;
                }
                else {
                    $('.er4').html('Пароль должен состоять минимум из 4 символов');
                }
            }
            else {
                $('.er4').html('Введите пароль');
            }

            return valid_password;
        }

        //Сброс поля с ошибкой
        function sbros(func,pole) {
            if (func) {
                $(pole).html('');
            }
        }
        var l = val_login();
        var n = val_name();
        var e = val_email();
        var p = val_password();
        return (l && n && e && p);
    }    
})(jQuery);